module.exports = __webpack_public_path__ + "static/media/contract.33a670ac.jpg";